import React, { useRef } from 'react';
import { UBTracking } from '../components/tracking/ubtracking.ts';
import { RestaurantDetails_getRestaurantDetails_menuCard_categories_entries_foodTags } from '../types/graphql-types-generated.ts';

export type FoodTagsProps =
  RestaurantDetails_getRestaurantDetails_menuCard_categories_entries_foodTags;

export function insertFoodTags(text: string | null, foodTags: object | null): React.ReactNode {
  if (null == foodTags || null == text) {
    return text ?? '';
  }

  const parts: React.ReactNode[] = [];
  let remainingText = text;

  for (const foodTag of Object.values(foodTags)) {
    const regex = new RegExp(`\\b${foodTag.name}\\b`, 'i');
    const match: RegExpMatchArray | null = remainingText.match(regex);
    const foodTagRef = useRef<HTMLAnchorElement>(null);

    if (match) {
      const before = remainingText.slice(0, match.index!);
      const matched = match[0];
      const after = remainingText.slice(match.index! + matched.length);

      if (before) {
        parts.push(before);
      }

      const FoodTagLink: React.FC<FoodTagsProps> = ({ name, url }) => {
        if (foodTagRef.current) {
          setTimeout(() => {
            UBTracking.onTrackTargetView(foodTagRef.current, 'menu_card', 'food_tag', name);
          }, 0);
        }

        return (
          <a
            ref={foodTagRef}
            href={`https://www.speisekarte.de${url}`}
            className="focus-visible:text-sk-red-500 hover:text-sk-red-500 cursor-pointer underline"
            onClick={() => {
              UBTracking.trackEvent.click('menu_card', 'food_tag', name);
            }}
          >
            #{name}
          </a>
        );
      };

      parts.push(
        React.createElement(FoodTagLink, {
          key: matched,
          name: foodTag.name,
          url: foodTag.url
        })
      );

      remainingText = after;
    }
  }

  if (remainingText) {
    parts.push(remainingText);
  }

  return parts;
}
